import endpoints from '@app/src/api/endpoints'
import { useCreateResource } from '@app/src/api/updateHooks'
import useErrorNotification from '@app/src/hooks/errorNotification'
import type { ReportCreateModel, Request } from '@app/src/types/resourceExplorer'
import { productReporting, reporting } from '@app/src/wf-constants/paths'
import { useHistory } from 'react-router'

export function useInquiryNavigator(): {
  isCreateReportLoading: false | true
  handleInquiryClick: (
    inquiryTemplateId: number,
    periodStartsAt: string,
    periodEndsAt: string,
    inquiryId: number,
    requestId?: number,
    targetProductId?: number,
  ) => Promise<void>
} {
  const { showErrorNotification } = useErrorNotification()
  const history = useHistory()
  const { mutateAsync, isPending: isCreateReportLoading } = useCreateResource<Request, ReportCreateModel>()

  const handleReportClick = async (
    inquiryTemplateId: number,
    periodStartsAt: string,
    periodsEndsAt: string,
    inquiryId: number,
    targetProductId?: number,
  ) => {
    if (isCreateReportLoading) return
    await mutateAsync(
      {
        url: endpoints.getOrCreateReport,
        body: {
          templateId: inquiryTemplateId,
          periodStartsAt: periodStartsAt,
          periodEndsAt: periodsEndsAt,
          inquiryId,
          targetProductId,
        },
      },
      {
        onError: error => {
          showErrorNotification({ requestError: error })
        },
        onSuccess: data => {
          const path = targetProductId ? productReporting : reporting
          history.push({ pathname: path, search: `requestId=${data.id}` })
        },
      },
    )
  }

  const handleInquiryClick = async (
    inquiryTemplateId: number,
    periodStartsAt: string,
    periodEndsAt: string,
    inquiryId: number,
    requestId?: number,
    targetProductId?: number,
  ) => {
    if (!requestId) {
      await handleReportClick(inquiryTemplateId, periodStartsAt, periodEndsAt, inquiryId, targetProductId)
      return
    }

    const path = targetProductId ? productReporting : reporting
    history.push({ pathname: path, search: `requestId=${requestId}` })
  }

  return { handleInquiryClick, isCreateReportLoading }
}
